import React, { useState, useEffect, useRef } from 'react';
import './ScrollHint.css';

function ScrollHint() {
  const [visible, setVisible] = useState(false);
  const [needsScroll, setNeedsScroll] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const checkScrollNeeded = () => {
      const hint = containerRef.current;
      if (!hint) return;

      // The carousel is a sibling - look in the parent's children
      const parent = hint.parentElement;
      const carousel = parent?.querySelector(
        '.teams-carousel, .graphics-carousel, .style-carousel, .template-carousel, .template-buttons'
      );

      if (carousel) {
        // Check if content is wider than container
        const hasOverflow = carousel.scrollWidth > carousel.clientWidth;
        setNeedsScroll(hasOverflow);

        if (hasOverflow) {
          setVisible(true);

          // Hide on scroll
          const handleScroll = () => {
            setVisible(false);
          };

          carousel.addEventListener('scroll', handleScroll);

          return () => {
            carousel.removeEventListener('scroll', handleScroll);
          };
        } else {
          // No overflow, make sure hint is hidden
          setVisible(false);
        }
      }
    };

    // Check immediately and after a short delay (for content to render)
    checkScrollNeeded();
    const delayTimer = setTimeout(checkScrollNeeded, 100);

    // Re-check on window resize
    window.addEventListener('resize', checkScrollNeeded);

    // Use MutationObserver to watch for DOM changes in the carousel
    const hint = containerRef.current;
    if (hint) {
      const parent = hint.parentElement;
      const carousel = parent?.querySelector(
        '.teams-carousel, .graphics-carousel, .style-carousel, .template-carousel'
      );

      if (carousel) {
        const observer = new MutationObserver(() => {
          // Re-check when carousel content changes
          setTimeout(checkScrollNeeded, 50);
        });

        observer.observe(carousel, {
          childList: true,
          subtree: true,
        });

        return () => {
          clearTimeout(delayTimer);
          window.removeEventListener('resize', checkScrollNeeded);
          observer.disconnect();
        };
      }
    }

    return () => {
      clearTimeout(delayTimer);
      window.removeEventListener('resize', checkScrollNeeded);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`scroll-hint ${visible ? 'visible' : 'hidden'}`}
      style={{ display: needsScroll ? 'flex' : 'none' }}
    >
      <span className="scroll-arrow">→</span>
      <span className="scroll-text">More</span>
    </div>
  );
}

export default ScrollHint;
